import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, endLoading, startSending, endSending } from "../progress/pogressSlice";
import { closeModal } from "../modal/modalSlice";
import { serverErrors } from "../";
import * as api from '../../api'

const initialState = { 
    modalities: [],
    status: 'idle'
}

const dir = 'modalities';

export const fetchModalities = createAsyncThunk('/modalities/fetch', async(_, thunkAPI) => {
    thunkAPI.dispatch(startLoading())
    try {
        const { data } = await api.getData(dir)
        thunkAPI.dispatch(endLoading());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
})

export const createModality = createAsyncThunk('/modalities/create', async({ values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.createNew(dir, values)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const editModality = createAsyncThunk('/modalities/edit', async({ id, values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.editData(dir, id, values)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const deleteModality = createAsyncThunk('/modalities/delete', async({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        await api.deleteItem(dir, id)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return id
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue()
    }
})

export const modalitiesSlice = createSlice({
    name: 'modalities',
    initialState,
    reducers: {},
    extraReducers(builder){
        builder
            .addCase(fetchModalities.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.modalities = action.payload
            })
            .addCase(createModality.fulfilled, (state, action) => {
                state.modalities = [action.payload, ...state.modalities]
            })
            .addCase(editModality.fulfilled, (state, action) => {
                Object.keys(state.modalities).forEach(function eachKey(key){
                    if(state.modalities[key].id === action.payload.id)
                        return state.modalities[key] = action.payload
                })
            })
            .addCase(deleteModality.fulfilled, (state, action) => {
                state.modalities = state.modalities.filter(t => t.id !== action.payload)
            })
    }
})

export default modalitiesSlice.reducer;